import { getAll } from '@bigyouth/base'
import emitter from '../utils/emitter'

const VALID_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
const VALID_TEL = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/ // eslint-disable-line
const VALID_DATE = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/

export const FORM_ACTIONS = {
  SUBMIT: 'FORM_SUBMIT',
}

export default {
  name: 'form-validation',
  hasError: false,

  ui: {
    form: 'form',
    'fields[]': '[js-field]',
    'requiredFields[]': '[js-required-field]',
    'mails[]': '[js-mail]',
    tel: '[js-tel]',
    'radios[]': '[js-radios]',
    'passwords[]': '[js-passwords]',
    'dates[]': '[js-dates]',
    'checkboxes[]': '[js-required-checkbox]',
  },

  events: [
    {
      target: 'form',
      on: 'submit',
      handle: 'onSubmit',
    },
  ],

  componentDidMount () {
    this.ui.form.setAttribute('novalidate', '')
  },

  onSubmit (e) {
    // TODO: Probably should be refactored. UI children should be automaticaly synced.
    this.ui.requiredFields = getAll('[js-required-field]', this.el)

    // reset
    this.hasError = false
    this.hideErrors()

    this.ui.fields.forEach(field => {
      field.classList.remove('has-error')
    })

    // check
    if (this.ui.requiredFields != null) {
      this.checkIfEmpty()
    }

    if (this.ui.mails != null) {
      this.checkEmail()
    }

    if (this.ui.tel != null) {
      this.checkTel()
    }

    if (this.ui.radios != null) {
      this.checkRadios()
    }

    if (this.ui.passwords != null) {
      this.checkPasswords()
    }

    if (this.ui.dates != null) {
      this.checkDates()
    }

    if (this.ui.checkboxes != null) {
      this.checkCheckboxes()
    }

    if (this.hasError) {
      e.preventDefault()
    } else if (this.props && this.props.formId) {
      e.preventDefault()
      emitter.trigger(FORM_ACTIONS.SUBMIT, { formId: this.props.formId })
    }
  },

  checkIfEmpty () {
    this.ui.requiredFields.forEach(field => {
      if (field.value.length === 0) {
        this.showError(window.shopifyTranslations.mandatoryField, field)
        this.hasError = true

        if (field.tagName === 'SELECT') {
          field.parentNode.parentNode.parentNode.classList.add('has-error')
        } else {
          field.parentNode.classList.add('has-error')
        }

        return false
      }
    })
  },

  checkRadios () {
    this.ui.radios.forEach(radio => {
      let inputs = getAll('input', radio)
      let count = 0

      inputs.forEach(input => {
        if (input.checked) {
          count++
        }
      })

      if (count === 0) {
        this.showError(window.shopifyTranslations.mandatoryField, radio)
        this.hasError = true
        radio.parentNode.classList.add('has-error')
      }
    })
  },

  checkPasswords () {
    this.ui.passwords.forEach(input => {
      const minChar = parseInt(input.getAttribute('minlength')) || 0
      const maxChar = parseInt(input.getAttribute('maxlength')) || Infinity

      if (input.value.length > maxChar || input.value.length < minChar) {
        this.showError(window.shopifyTranslations.sizePassword, input)
        this.hasError = true
        input.parentNode.classList.add('has-error')
      }
    })
  },

  checkDates () {
    this.ui.dates.forEach(input => {
      if (input.value.length > 0 && !VALID_DATE.test(input.value)) {
        this.showError(window.shopifyTranslations.dateFormat, input)
        this.hasError = true
        input.setAttribute('required', '')
        input.parentNode.classList.add('has-error')
      }
    })
  },

  checkCheckboxes () {
    this.ui.checkboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        this.showError(window.shopifyTranslations.mandatoryField, checkbox)
        this.hasError = true
        checkbox.parentNode.classList.add('has-error')
      }
    })
  },

  checkEmail () {
    this.ui.mails.forEach(field => {
      let isCorrect = VALID_EMAIL.test(field.value)

      if (field.value.length === 0) return

      if (!isCorrect) {
        this.showError(window.shopifyTranslations.mandatoryEmail, field)
        this.hasError = true
        field.parentNode.classList.add('has-error')
        return false
      }
    })
  },

  checkTel () {
    const tel = this.ui.tel
    let isCorrect = VALID_TEL.test(tel.value)

    if (tel.value.length === 0) return

    if (!isCorrect) {
      this.showError(window.shopifyTranslations.mandatoryPhone, tel)
      this.hasError = true
      tel.parentNode.classList.add('has-error')
      return false
    }
  },

  showError (msg, field) {
    let error = document.createElement('p')

    error.classList.add('form-error', 'mb-4')
    error.innerHTML = msg

    if (field.tagName === 'SELECT') {
      field.parentNode.parentNode.parentNode.parentNode.appendChild(error)
    } if (field.classList.contains('js-datepicker')) {
      field.parentNode.parentNode.parentNode.appendChild(error)
    } else {
      field.parentNode.appendChild(error)
    }
  },

  hideErrors () {
    this.ui.fields.forEach(field => {
      const errors = getAll('.form-error', field)

      errors.forEach(error => {
        field.removeChild(error)
      })
    })
  },
}
